class CartDiscountField extends HTMLElement {
  constructor() {
    super();
    this.submitButton = this.querySelector("#sc-discount__submit");
    this.codeInput = this.querySelector("#code");
    this.warningMessage = this.querySelector(".sc-message--warning");
    this.loader = this.querySelector(".sc_code-loading");

    this.boundApplyDiscount = this.applyDiscount.bind(this);
    this.boundRemoveDiscount = this.removeDiscount.bind(this);
    this.boundHandleProductAdded = this.handleProductAdded.bind(this);
    this.boundhandleKeyDown = this.handleKeyDown.bind(this);
    this.boundHandleCartRefresh = () => {
      this.classList.remove("disabled-discount-field");
    };
    this.cart = this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.unsubscribeProductAdded = null;
  }

  connectedCallback() {
    this.codesArray = Array.from(
      document.querySelectorAll(
        '.code-name[data-discount-type="discount_code"]'
      )
    ).map((element) => element.getAttribute("title"));

    this.codeRemovers = this.querySelectorAll(".code-remover");
    this.codeInput.addEventListener("keydown", this.boundhandleKeyDown);
    this.submitButton.addEventListener("click", this.boundApplyDiscount);
    this.codeRemovers.forEach((remover) => {
      remover.addEventListener("click", this.boundRemoveDiscount);
    });

    //Theme specific Event Listeners
    document.addEventListener("cart:refresh", this.boundHandleCartRefresh);
    document.addEventListener("product:added", this.boundHandleProductAdded);
    this.unsubscribeProductAdded = subscribe(PUB_SUB_EVENTS.productAdded, this.boundHandleProductAdded);
    if (this.classList.contains('scDiscount__container--disabled')) {
      this.clearDiscounts();
    }
  }

  disconnectedCallback() {
    this.codeInput.removeEventListener("keydown", this.boundhandleKeyDown);
    this.submitButton.removeEventListener("click", this.boundApplyDiscount);
    this.codeRemovers.forEach((remover) => {
      remover.removeEventListener("click", this.boundRemoveDiscount);
    });

    document.removeEventListener("cart:refresh", this.boundHandleCartRefresh);
    document.removeEventListener("product:added", this.boundHandleProductAdded);
    if (this.unsubscribeProductAdded) {
      this.unsubscribeProductAdded();
    }
  }

  handleKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.boundApplyDiscount();
    }
  }

  async handleProductAdded(event) {
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (
      event.detail.variant.properties?._discount_code &&
      event.detail.variant.properties?._discount_code_product
    ) {
      const discountCode = event.detail.variant.properties._discount_code;
      var discountCodeProduct = event.detail.variant.properties._discount_code_product.replace(/^gid:\/\/shopify\/ProductVariant\//, '');
      discountCodeProduct = parseInt(
        discountCodeProduct,
        10
      );

      this.applyDiscount(event, discountCode, discountCodeProduct);
    }
  }

  removeDiscount(e) {
    this.classList.add("disabled-discount-field");
    const removerButton = e.target.closest(".code-remover");
    if (!removerButton) {
      console.error("Could not find the code remover button");
      return;
    }
    const code = removerButton.getAttribute("title");

    console.log("Removing discount", code);
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        this.discountRemover.bind(this)(code, cart);
      });
  }

  async applyDiscount(event, discountCode, discountProduct) {
    console.log("Applying discount");
    this.submitButton.style.display = "none";
    this.loader.style.display = "block";
    const code = discountCode || this.codeInput.value;
    if (!code) {
      console.error("Discount code cannot be empty");
      this.submitButton.style.display = "block";
      this.loader.style.display = "none";
      return;
    }
    fetch("/cart.js")
      .then((response) => response.json())
      .then(async (cart) => {
        const discountMatch = window.discountProduct?.filter(
          (product) => product.discountCode.toLowerCase() === code.toLowerCase()
        );

        const isParentProductInCart = cart.items.some(
          (item) => item.product_id === discountMatch[0]?.parentProductId);
        const noParentProduct = discountMatch[0]?.noParentProduct;
        const isFreeProductInCart =
          discountMatch &&
          discountMatch.length > 0 &&
          cart.items.some(
            (item) => item.variant_id === discountMatch[0].variantId
          );

        if (discountProduct) {
          var isDiscountProductInCart = cart.items.some(
            (item) => item.variant_id === discountProduct
          );
        }

        if (!isDiscountProductInCart && discountProduct) {
          this.productAdder(discountProduct, code, cart);
        } else if (
          discountMatch &&
          discountMatch.length > 0 &&
          discountMatch[0].variantId &&
          !isFreeProductInCart && (isParentProductInCart || noParentProduct)
        ) {
          this.productAdder(discountMatch[0].variantId, code, cart);
        } else {
          this.discountApplicator.bind(this)(code, cart);
        }
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }

  async productAdder(variantId, code, cart) {
    code = code.trim();
    this.codesArray = [code];

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [variantId]: 1
        },
        discount: this.codesArray.join(','),
        sections: this.cart
          .getSectionsToRender()
          .map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then(async (data) => {
        console.log("Product added to cart:", data);
        if (this.cart) {
          const updatedData = await this.getCartData();
          const renderData = updatedData || data;
          this.cart.renderContents(renderData);
          updateFreeShipping();
        }
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  async getCartData() {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sections: this.cart
            .getSectionsToRender()
            .map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching cart data:", error);
      // Consider re-throwing or returning a default value
      throw error; // or return null;
    }
  }

  async discountApplicator(code, cart) {
    code = code.trim();

    const normalizedCode = code.trim().toLowerCase();
    const discountsToRemove = this.codesArray.filter((existingCode) =>
      existingCode.toLowerCase() !== normalizedCode
    );

    for (const discount of discountsToRemove) {
      this.discountRemover(discount, cart, false);
    }
    this.codesArray = [code];

    try {
      const applyDiscount = await fetch('/cart/update.js',
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            discount: this.codesArray.join(','),
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.section),
            sections_url: window.location.pathname,
          }),
        }
      )

      const data = await applyDiscount.json();
      const discountError = data.discount_codes.some(
        (discount) =>
          discount.code &&
          !discount.applicable
      );

      if (!discountError) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-drawer',
          cartData: data,
        });
      }

      updateFreeShipping();
      this.submitButton.style.display = "block";
      this.loader.style.display = "none";
      if (
        data.discount_codes.userErrors &&
        data.discount_codes.userErrors?.length > 0
      ) {
        this.warningMessage.style.display = "block";
      } else if (
        data.discount_codes &&
        data.discount_codes.length > 0
      ) {
        const appliedCode = code ? code.toLowerCase() : "";
        const foundDiscountEntry =
          data.discount_codes.find(
            (discount) =>
              discount.code && discount.code.toLowerCase() === appliedCode
          );

        if (foundDiscountEntry && !foundDiscountEntry.applicable) {
          this.warningMessage.style.display = "block";
        } else {
          this.warningMessage.style.display = "none";
        }
      } else {
        this.warningMessage.style.display = "none";
      }
    } catch (error) {
      console.error("Error updating order:", error);
    }
  }

  async discountRemover(code, cart, cartRefresh = true) {

    if (code) {
      this.codesArray = this.codesArray.filter((item) => item !== code);
    }

    try {
      const removeDiscount = await fetch('/cart/update.js',
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            discount: this.codesArray.join(','),
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.section),
            sections_url: window.location.pathname,
          }),
        }
      )

      const data = await removeDiscount.json();
      if (cartRefresh && this.cart) {
        this.cart.renderContents(data);
        updateFreeShipping();
      }

      const discountProducts = window.discountProduct?.filter(
        (product) =>
          product.discountCode.toLowerCase() === code?.toLowerCase()
      );

      if (!discountProducts || discountProducts.length === 0) {
        return;
      }

      const variantId = discountProducts[0].variantId;
      const discountCode = discountProducts[0].discountCode;

      if (
        cart.items.some(
          (item) =>
            item.variant_id === variantId && discountCode.toLowerCase() === code?.toLowerCase()
        )
      ) {
        const data = await fetch("/cart.js");
        cart = await data.json();
        const item = cart.items.find(
          (item) =>
            item.variant_id === variantId
        );
        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0,
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.section),
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Product removed from cart:", data);
            if (this.cart && cartRefresh) {
              this.cart.renderContents(data);
              updateFreeShipping();
            }
          })
          .catch((error) => {
            console.error("Error removing product from cart:", error);
          });
      }
    } catch (error) {
      console.error("Error updating order:", error);
    }
  }

  async clearDiscounts() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        if (cart.discount_codes.length > 0) {
          this.codesArray = [];
          this.discountRemover.bind(this)(null, cart);
        }
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }
}

customElements.define("cart-discount-field", CartDiscountField);